import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a18958a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 text-decoration-none",
    href: "#",
    "data-bs-toggle": "modal",
    "data-bs-target": "#CreateProductModal"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline" }, "Criar produto"),
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative fs-12 product-create-icon" })
  ])
], -1))
const _hoisted_4 = {
  class: "d-flex align-items-center w-100 ms-lg-auto",
  style: {"max-width":"350px","position":"relative","z-index":"99"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Comece a digitar para buscar produtos.", -1))
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25 mt-10" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " SKU "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Descrição "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Preço "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Editar "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Deletar ")
  ])
], -1))
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20" }
const _hoisted_27 = { class: "fs-14 text-muted mb-10 mb-sm-0" }
const _hoisted_28 = { "aria-label": "Paginação de produtos" }
const _hoisted_29 = { class: "pagination mb-0" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteProductModal = _resolveComponent("DeleteProductModal")!
  const _component_CreateProductModal = _resolveComponent("CreateProductModal")!
  const _component_UpdateProductModal = _resolveComponent("UpdateProductModal")!
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteProductModal),
    _createVNode(_component_CreateProductModal),
    _createVNode(_component_UpdateProductModal),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_multiselect, {
            ref: "productSelect",
            modelValue: _ctx.selectedSearchProduct,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSearchProduct) = $event)),
            options: _ctx.getProductsSearchList,
            searchable: true,
            loading: _ctx.isLoadingProducts,
            "internal-search": false,
            "custom-label": _ctx.formatProductOption,
            taggable: false,
            label: "name",
            "track-by": "id",
            "no-options-text": "Nenhum produto encontrado.",
            "no-result-text": "Nenhum resultado para sua busca.",
            placeholder: "Buscar produto...",
            onSearchChange: _ctx.debouncedFetchProducts,
            onSelect: _ctx.onProductSelect,
            "close-on-select": true,
            id: "product_search",
            class: "w-100"
          }, {
            noOptions: _withCtx(() => [
              _hoisted_5
            ]),
            noResult: _withCtx(() => [
              _createTextVNode(" Nenhum produto encontrado ")
            ]),
            _: 1
          }, 8, ["modelValue", "options", "loading", "custom-label", "onSearchChange", "onSelect"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductCatalogList, (value, key) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: value.id || key
                }, [
                  _createElementVNode("th", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(value.name != '' && value.name != null  ? value.name : 'Sem nome'), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("span", {
                      class: "product-table__sku",
                      title: value.sku || ''
                    }, _toDisplayString(_ctx.formatSku(value.sku)), 9, _hoisted_14)
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("span", {
                      class: "product-table__description",
                      title: value.description || ''
                    }, _toDisplayString(_ctx.formatDescription(value.description)), 9, _hoisted_16)
                  ]),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(value.price != '' && value.price != null  ? 'R$ ' + parseFloat(value.price).toFixed(2).replace('.', ',') : '-'), 1),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.setCurrentUpdateProduct(value)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#UpdateProductModal",
                      class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                      type: "button"
                    }, _hoisted_21, 8, _hoisted_19)
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.setCurrentDeleteProduct(value)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#DeleteProductModal",
                      class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                      type: "button"
                    }, _hoisted_25, 8, _hoisted_23)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, " Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.getProductCatalogPagination.last_page || 1) + " — Total de " + _toDisplayString(_ctx.getProductCatalogPagination.total || _ctx.getProductCatalogList.length) + " produtos ", 1),
          _createElementVNode("nav", _hoisted_28, [
            _createElementVNode("ul", _hoisted_29, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage <= 1 }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "page-link",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1))),
                  disabled: _ctx.currentPage <= 1
                }, " Anterior ", 8, _hoisted_30)
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage >= _ctx.getProductCatalogPagination.last_page }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "page-link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1))),
                  disabled: _ctx.currentPage >= _ctx.getProductCatalogPagination.last_page
                }, " Próxima ", 8, _hoisted_31)
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}